import type { OnboardingLabels } from "./types";

export const onboardingLabelsTr: OnboardingLabels = {
  meta: {
    pageTitle: "Paptoq Business'a hoş geldin",
    pageSubtitle: "İşletmeni 5 dakikadan kısa sürede kuralım.",
  },
  steps: {
    1: { title: "Hesap", description: "Sahip hesabını oluştur" },
    2: { title: "İşletme", description: "İşletme künyeni gir" },
    3: { title: "Şube", description: "İlk şubeni tanımla" },
  },
  account: {
    email: "E-posta",
    emailPlaceholder: "ornek@isletme.com",
    password: "Şifre",
    passwordPlaceholder: "En az 8 karakter",
    displayName: "Adın Soyadın",
    displayNamePlaceholder: "Ayşe Yılmaz",
    locale: "Dil tercihi",
    localeTr: "Türkçe",
    localeEn: "English",
    acceptTerms: "Kullanım koşullarını ve gizlilik sözleşmesini okudum, kabul ediyorum.",
    marketingOptIn: "Ürün güncellemeleri ve ipuçları için e-posta almak istiyorum.",
    strength: { weak: "Zayıf", fair: "Orta", good: "İyi", strong: "Güçlü" },
  },
  business: {
    name: "İşletme adı",
    namePlaceholder: "PatiSpa Kuaför Salonu",
    taxId: "Vergi Kimlik No (VKN)",
    taxIdPlaceholder: "10 haneli VKN",
    countryCode: "Ülke",
    subVertical: "Hizmet alanın",
    subVerticalSubtitle: "Bu, varsayılan modülleri ve çalışma motorunu belirler.",
    subVerticalHint: "Sonradan ek hizmet alanı ekleyebilirsin.",
    categories: {
      grooming: "Kuaför",
      veterinary: "Veteriner",
      boarding: "Pansiyon",
      training: "Eğitim",
      walking: "Yürüyüş",
      daycare: "Kreş",
      "mobile-service": "Mobil",
      retail: "Perakende",
    },
    complianceBadge: "Lisans gerekir",
    filterAll: "Tümü",
    searchPlaceholder: "Hizmet ara…",
  },
  branch: {
    name: "Şube adı",
    namePlaceholder: "Merkez Şube",
    address: {
      street: "Adres",
      streetPlaceholder: "Cadde, sokak, no",
      district: "İlçe",
      city: "İl",
      postalCode: "Posta kodu",
      postalCodePlaceholder: "34000",
    },
    timezone: "Zaman dilimi",
    phone: "Telefon",
    phonePlaceholder: "+90 555 000 0000",
    operatingHours: "Çalışma saatleri (önizleme)",
    operatingHoursHint: "Hizmet alanına göre öneriliyor — sonra ayarlayabilirsin.",
    weekdays: ["Paz", "Pzt", "Sal", "Çar", "Per", "Cum", "Cmt"],
    closed: "Kapalı",
  },
  actions: {
    next: "Devam et",
    back: "Geri",
    submit: "İşletmemi kur",
    resume: "Kaldığım yerden devam et",
    startOver: "Baştan başla",
  },
  errors: {
    required: "Bu alan zorunlu.",
    invalid_email: "Geçerli bir e-posta gir.",
    min_length: "Çok kısa.",
    max_length: "Çok uzun.",
    requires_letter: "En az bir harf içermeli.",
    requires_digit: "En az bir rakam içermeli.",
    invalid_format: "Format hatalı.",
    invalid_checksum: "VKN doğrulanamadı.",
    invalid_postal_code: "Posta kodu geçersiz.",
    invalid_phone: "Telefon E.164 formatında olmalı (+90…).",
    sub_vertical_not_found: "Bu hizmet alanı bulunamadı.",
    terms_not_accepted: "Devam etmek için koşulları kabul et.",
    email_already_exists: "Bu e-posta zaten kayıtlı. Giriş yapmak ister misin?",
    tax_id_already_exists: "Bu VKN ile bir işletme zaten kayıtlı. Destek ile iletişime geç.",
    too_many_attempts: "Çok fazla deneme. Lütfen birkaç dakika bekle.",
    idempotency_conflict: "İşlem çakışması. Sayfayı yenile ve tekrar dene.",
    provisioning_failed: "İşletme oluşturulamadı. Lütfen tekrar dene.",
    network: "Ağ hatası. Bağlantını kontrol et.",
  },
  success: {
    title: "İşletmen hazır 🎉",
    subtitle: "E-posta doğrulama bağlantısı kutuna gönderildi.",
    continueToDashboard: "Panele git",
    nextSteps: [
      { title: "İlk hizmetini ekle", description: "Kuaför, bakım veya muayene paketleri.", cta: "Hizmet ekle" },
      { title: "Personelini davet et", description: "Ekip arkadaşlarını sisteme dahil et.", cta: "Davet gönder" },
      { title: "İlk randevunu oluştur", description: "Müşterini ekle, takvime yerleştir.", cta: "Randevu oluştur" },
    ],
  },
  resumeBanner: {
    title: "Yarım kalmış bir kayıt buldum",
    subtitle: "Kaldığın yerden devam et veya baştan başla.",
  },
  loginLink: "Hesabın var mı? Giriş yap",
  hero: {
    eyebrow: "Paptoq Business",
    headline: "Pet işletmen için sakin, güçlü bir işletim sistemi.",
    bullets: [
      "Randevu, müşteri ve ekip — tek panelde",
      "Vergi mevzuatına uygun, KVKK uyumlu altyapı",
      "iPad, masaüstü ve telefonda kusursuz çalışır",
    ],
    socialProof: "Türkiye'de 1.200+ pet işletmesi tarafından tercih ediliyor.",
  },
  taxIdBadge: { valid: "VKN geçerli", invalid: "VKN geçersiz", idle: "10 hane" },
  stepStatus: { current: "Şu anki adım", done: "Tamamlandı", pending: "Bekliyor" },
};

export const onboardingLabelsEn: OnboardingLabels = {
  meta: {
    pageTitle: "Welcome to Paptoq Business",
    pageSubtitle: "Let's set up your business in under 5 minutes.",
  },
  steps: {
    1: { title: "Account", description: "Create the owner account" },
    2: { title: "Business", description: "Tell us about your business" },
    3: { title: "Branch", description: "Define your first branch" },
  },
  account: {
    email: "Email",
    emailPlaceholder: "you@business.com",
    password: "Password",
    passwordPlaceholder: "At least 8 characters",
    displayName: "Full name",
    displayNamePlaceholder: "Jane Doe",
    locale: "Language",
    localeTr: "Türkçe",
    localeEn: "English",
    acceptTerms: "I accept the Terms of Service and Privacy Policy.",
    marketingOptIn: "Send me product updates and tips by email.",
    strength: { weak: "Weak", fair: "Fair", good: "Good", strong: "Strong" },
  },
  business: {
    name: "Business name",
    namePlaceholder: "PatiSpa Grooming",
    taxId: "Tax ID (VKN)",
    taxIdPlaceholder: "10-digit Turkish VKN",
    countryCode: "Country",
    subVertical: "Service vertical",
    subVerticalSubtitle: "Defines default modules and the booking engine.",
    subVerticalHint: "You can add more verticals later.",
    categories: {
      grooming: "Grooming",
      veterinary: "Veterinary",
      boarding: "Boarding",
      training: "Training",
      walking: "Walking",
      daycare: "Daycare",
      "mobile-service": "Mobile",
      retail: "Retail",
    },
    complianceBadge: "License required",
    filterAll: "All",
    searchPlaceholder: "Search verticals…",
  },
  branch: {
    name: "Branch name",
    namePlaceholder: "Main branch",
    address: {
      street: "Street address",
      streetPlaceholder: "Street, number",
      district: "District",
      city: "City",
      postalCode: "Postal code",
      postalCodePlaceholder: "34000",
    },
    timezone: "Time zone",
    phone: "Phone",
    phonePlaceholder: "+90 555 000 0000",
    operatingHours: "Operating hours (preview)",
    operatingHoursHint: "Suggested for your vertical — adjust later.",
    weekdays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    closed: "Closed",
  },
  actions: {
    next: "Continue",
    back: "Back",
    submit: "Create my business",
    resume: "Resume where you left off",
    startOver: "Start over",
  },
  errors: {
    required: "This field is required.",
    invalid_email: "Enter a valid email.",
    min_length: "Too short.",
    max_length: "Too long.",
    requires_letter: "Must contain a letter.",
    requires_digit: "Must contain a digit.",
    invalid_format: "Invalid format.",
    invalid_checksum: "VKN checksum failed.",
    invalid_postal_code: "Invalid postal code.",
    invalid_phone: "Phone must be in E.164 format (+90…).",
    sub_vertical_not_found: "Vertical not found.",
    terms_not_accepted: "Please accept the terms to continue.",
    email_already_exists: "This email is already registered. Sign in instead?",
    tax_id_already_exists: "A business with this Tax ID already exists. Contact support.",
    too_many_attempts: "Too many attempts. Wait a few minutes.",
    idempotency_conflict: "Conflict — refresh and try again.",
    provisioning_failed: "Could not create the business. Please retry.",
    network: "Network error. Check your connection.",
  },
  success: {
    title: "Your business is ready 🎉",
    subtitle: "We sent a verification link to your inbox.",
    continueToDashboard: "Go to dashboard",
    nextSteps: [
      { title: "Add your first service", description: "Grooming, care or check-up packages.", cta: "Add service" },
      { title: "Invite your team", description: "Bring your staff into the system.", cta: "Send invite" },
      { title: "Book the first appointment", description: "Add a customer, drop on the calendar.", cta: "Create appointment" },
    ],
  },
  resumeBanner: {
    title: "We found an unfinished signup",
    subtitle: "Continue where you left off or start over.",
  },
  loginLink: "Already have an account? Sign in",
  hero: {
    eyebrow: "Paptoq Business",
    headline: "A calm, powerful operating system for your pet business.",
    bullets: [
      "Bookings, customers and staff — one console",
      "Tax-compliant, KVKK-ready infrastructure",
      "Flawless on iPad, desktop and mobile",
    ],
    socialProof: "Trusted by 1,200+ pet businesses across Turkey.",
  },
  taxIdBadge: { valid: "Valid VKN", invalid: "Invalid VKN", idle: "10 digits" },
  stepStatus: { current: "Current step", done: "Done", pending: "Pending" },
};
